import Brand from "../Brand";
import Company from "../Company";
import Model from "../Model";
import Product from "../Product";

export default class ProfileAssociation extends Model {
  static type = "clientsAdcontrolMatches";

  vatNumber!: string;
  companyPrincipalId!: number;
  companyPrincipalName!: string;
  company!: Company;

  brand!: Brand;

  productPrincipalId?: number;
  productPrincipalName?: string;
  product?: Product;

  matchDate!: string;
  ignored!: boolean;
}
